/**
 * Deep-merge plain JSON-like objects. Arrays and primitives from `override` replace entirely.
 * Used so locale bundles can omit keys and inherit from English.
 * Always returns a deep clone of `base` (never mutates the original).
 */
export function deepMergeTranslations<T>(base: T, override: unknown): T {
  const clone = JSON.parse(JSON.stringify(base)) as T;
  if (override === undefined || override === null) return clone;
  if (typeof clone !== "object" || clone === null || Array.isArray(clone)) {
    return override as T;
  }
  if (typeof override !== "object" || Array.isArray(override) || override === null) {
    return override as T;
  }
  const b = clone as Record<string, unknown>;
  const o = override as Record<string, unknown>;
  for (const key of Object.keys(o)) {
    const bv = b[key];
    const ov = o[key];
    if (ov === undefined) continue;
    if (
      bv !== null &&
      typeof bv === "object" &&
      !Array.isArray(bv) &&
      ov !== null &&
      typeof ov === "object" &&
      !Array.isArray(ov)
    ) {
      b[key] = deepMergeTranslations(bv as T, ov) as unknown;
    } else {
      b[key] = ov;
    }
  }
  return clone;
}
